export default function IndexRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider.state('index', {
    url: '/index',
    template: '<p></p>',
    requiredDatapoints: ['gps'],
    requiredFeatures: ['map'],
    controller: function ($state, $location) {
      'ngInject';

      const path = $location.path();
      if (path && !path.toLowerCase().endsWith('index')) {
        $state.go(path);
      }

      $state.go('map');
    }
  });
}